import { useRef, useState } from 'react';

export const useApplyHighlight = (duration: number = 3000) => {
    const [highlightClass, setHighLightClass] = useState<any>({})

    const applyHighlight = (id: string, className: string = 'highlight-yellow', options: { autoHide: boolean }) => {
        let currentClasses = { ...highlightClass, [id]: `d-block ${className}` }
        setHighLightClass(currentClasses)
        setTimeout(() => {
            setHighLightClass({ ...currentClasses, [id]: "d-block" })
            if (options.autoHide === true) {
                setHighLightClass({ ...currentClasses, [id]: "d-none" })
            }
        }, duration);
    }
    return { applyHighlight, highlightClass };
}